import { Box, Button, TextField, Typography } from "@mui/material"
import AuthCard from "../AuthCard/AuthCard.wrapper"
import { useState } from "react"
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "react-toastify";

const ForgotPassword = () => {
    const [email, setEmail] = useState('');

    const handleForgotPassword = useMutation({
        mutationFn: async (data :{email: string}) => {
            const response = await axios.post('https://interviewer.runasp.net/api/users/forgot-password',{ email: data.email })
            return response.data
        },
        onSuccess: (data) => {
            toast.success('We’ve sent you a password reset link. Please check your email.')
        },
        onError: (error) =>  {
            console.log(error);
        }
    })

return (
    <>
        <AuthCard>
             <Box sx={{pb: '16px'}}>
                <Typography variant="h1">Forgot password?</Typography>
                <Typography sx={{pt: '8px'}} variant="h4">Enter your email address and we will send you a password reset link.</Typography>
            </Box>
            <TextField
                required
                label="Enter your email" 
                variant="outlined" 
                fullWidth 
                value={email}
                type='email'
                onChange={(e) => setEmail(e.target.value)}
            />

             <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleForgotPassword.mutate({ email })}
            >
                Send
            </Button>
        </AuthCard>
    </>
)

}
export default ForgotPassword